module.exports = __webpack_public_path__ + "img/xydpjxt.0949e90a.png";